import Link from 'next/link';
import React from 'react';

export const AcServiceLocality = ({ localityList }) => {
  const filteredLocalities = localityList.filter((loc) => loc !== 'Singapore');

  return (
    <section className="leading-7 px-4 py-12 bg-gray-50" aria-label="Aircon Servicing Localities">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl font-semibold text-center uppercase text-gray-800 mb-6">
          Aircon Servicing in Your Neighborhood
        </h2>
        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-4">
          {filteredLocalities.map((locality, i) => (
            <li key={i} className="flex justify-center">
              <Link
                href={`/sg/aircon-servicing-singapore/locality/${encodeURIComponent(locality)}`}
                prefetch={false}
                className="text-orange-600 text-base hover:underline"
              >
                {locality}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
